import { api } from "@/lib/api/client";
import type { Participant, Room, RoomSettings } from "@/lib/api/types";
import type { Stage } from "@/lib/stage";

export type RoomPreview = {
  slug: string;
  title: string;
  allowGuests: boolean;
  lobby: boolean;
  requiresPasscode: boolean;
  live: boolean;
  participantCount: number;
  hostName: string;

  stage: Stage;
  autoJoin: boolean;
  muteOnEntry: boolean;
  cameraOffOnEntry: boolean;
};

export function listRooms(): Promise<Room[]> {
  return api<Room[]>("rooms");
}

export function createRoom(input: {
  title?: string;
  settings?: Partial<RoomSettings>;
}): Promise<Room> {
  return api<Room>("rooms", { method: "POST", body: input });
}

export function getRoom(slug: string): Promise<Room> {
  return api<Room>(`rooms/${slug}`);
}

export function previewRoom(slug: string): Promise<RoomPreview> {
  return api<RoomPreview>(`rooms/${slug}/preview`, { anonymous: true });
}

export function updateRoom(
  id: string,
  input: {
    title?: string;
    settings?: Partial<RoomSettings>;
  },
): Promise<Room> {
  return api<Room>(`rooms/${id}`, { method: "PATCH", body: input });
}

export function deleteRoom(id: string): Promise<void> {
  return api<void>(`rooms/${id}`, { method: "DELETE" });
}

export function roomParticipants(id: string): Promise<Participant[]> {
  return api<Participant[]>(`rooms/${id}/participants`);
}

export type RoomRecording = {
  recording: {
    id: string;
    roomId: string;
    callId: number;
    startedAt: string;
    endedAt: string | null;
    recording: boolean;
    durationMs: number;
    startedByName: string | null;
    stopReason: string | null;
  };

  path: string;
};

export function roomRecordings(slug: string): Promise<RoomRecording[]> {
  return api<RoomRecording[]>(`rooms/${encodeURIComponent(slug)}/recordings`);
}
